import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, WritableSignal, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';
import { Process } from 'app/api';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import { ProcessService } from '../process.service';
import { MasterProcessSelectionTreeComponent } from '../processes/processes-tree/master-process-selection-tree.component';

@Component({
    selector: 'create-process-from-master-dialog',
    standalone: true,
    imports: [CommonModule, MasterProcessSelectionTreeComponent, MatButtonModule, TranslocoModule],
    templateUrl: './create-process-from-master-dialog.component.html',
    styleUrl: './create-process-from-master-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateProcessFromMasterDialogComponent extends DialogBuilderComponent<any> {
    // Should load processes that are not in the BPLS and that are linked to a business domain that is available in the current organisation
    systemBPLS: WritableSignal<Process[]> = signal([]);

    selectedId: WritableSignal<string> = signal(null);

    constructor(private _processService: ProcessService) {
        super();

        this._processService.getSystemBpls().subscribe(bpls => {
            this.systemBPLS.set(bpls);
        });
    }

    onTreeNodeSelectionChanged(id: string) {
        this.selectedId.set(id);
    }

    cancel(): void {
        this.closeDialog();
    }

    private getProcessById(id: string): Process {
        return this.systemBPLS().find(p => p.id === id);
    }

    createProcessCopy(): void {
        this.closeDialog({
            process: this.getProcessById(this.selectedId()),
            type: 'createProcess',
        });
    }

    createProcessLink(): void {
        this.closeDialog({
            process: this.getProcessById(this.selectedId()),
            type: 'createProcessLink',
        });
    }
}
